import ApiService from "@/utils/api.service";
import JwtService from "@/utils/jwt.service";

export default {
    login(context, credentials) {
        return new Promise((resolve, reject) => {
            context.commit("setLoading", true);
            ApiService.post("auth/login", credentials)
                .then(({ data }) => {
                    if (data.error) {
                        console.log("error");
                    } else if (data.token) {
                        context.commit("setAuth", data);
                        resolve(data);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    context.commit("setLoading", false);
                });
        });
    },
    logout(context) {
        context.commit("purge_auth");
    },

    check_auth(context) {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.get("user").then(({ data }) => {
                if (data.message) {
                    context.commit("purge_auth");
                } else {
                    context.commit("setUser", data);
                }
            });
        } else {
            context.commit("purge_auth");
        }
    },

    createAccount(context, params) {
        return new Promise(resolve => {
            context.commit("setLoading", true);
            ApiService.post("auth/subscribe", params)
                .then(({ data }) => {
                    if (data.error) {
                        console.log("error");
                    } else if (data.token) {
                        context.commit("setAuth", data);
                        resolve(data);
                    }
                })
                .finally(() => {
                    context.commit("setLoading", false);
                });
        });
    },
    update(context) {
        return new Promise(resolve => {
            context.commit("setLoading", true);
            ApiService.put("user", context.state.user)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.commit("setLoading", false);
                });
        });
    },
    changePassword(context, params) {
        return new Promise((resolve, reject) => {
            context.commit("setLoading", true);
            ApiService.put("user/password", params)
                .then(({ data }) => {
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.commit("setLoading", false);
                });
        });
    },
    updateMoneyRequest(context, requests) {
        context.commit("updateMoneyRequest", requests);
    },
    recovery(context, model) {
        return new Promise(resolve => {
            context.commit("setLoading", true);
            ApiService.post("auth/lost", model)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.commit("setLoading", false);
                });
        });
    },
    
    reset(context, model) {
        return new Promise(resolve => {
            context.commit("setLoading", true);
            ApiService.post("auth/reset", model)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.commit("setLoading", false);
                });
        });
    },
}